<template>
  <div class="pt-4">
    <!-- Class sits on the heading itself, as in every other homepage section.
         Nesting an <h3> inside a .hp-block-title div meant the heading scale
         won and this title rendered smaller than its siblings. -->
    <h3 class="hp-block-title mt-5">We insure all types of bikes</h3>

    <div
      class="image-container is-flex is-justify-content-space-evenly mt-5 pb-5"
    >
      <div>
        <router-link
          to="/road-bike-insurance"
          class="type-card is-flex is-flex-direction-column"
        >
          <figure class="image">
            <img
              alt="Bike"
              src="~/assets/images/typeInsurances/Road Bike Woman.svg"
            />
          </figure>
          <div class="card-title px-5 py-5">Road Bike Insurance</div>
          <div class="ps-button short is-outlined button read-more mb-5">
            Learn more
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          to="/electric-bike-insurance"
          class="type-card is-flex is-flex-direction-column"
        >
          <figure class="image">
            <img alt="Bike" src="~/assets/images/typeInsurances/E-bike.svg" />
          </figure>
          <div class="card-title px-5 py-5">E-bike Insurance</div>
          <div class="ps-button short is-outlined button read-more mb-5">
            Learn more
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          to="/mountain-bike-insurance"
          class="type-card is-flex is-flex-direction-column"
        >
          <figure class="image">
            <img
              alt="Bike"
              src="~/assets/images/typeInsurances/Mountain-Bike.svg"
            />
          </figure>
          <div class="card-title px-5 py-5">Mountain Bike Insurance</div>
          <div class="ps-button short is-outlined button read-more mb-5">
            Learn more
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          to="/cargo-bike-insurance"
          class="type-card is-flex is-flex-direction-column"
        >
          <figure class="image">
            <img
              alt="Bike"
              src="~/assets/images/typeInsurances/Cargo Bike Woman.svg"
            />
          </figure>
          <div class="card-title px-5 py-5">Cargo Bike Insurance</div>
          <div class="ps-button short is-outlined button read-more mb-5">
            Learn more
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
// Same card as the "Learn more about cycling insurance" blocks
// (components/blog-widget/CardVertical.vue). Structure is deliberately
// identical: media band, title block, action button.
.type-card {
  border-radius: $ps-radius-lg;
  overflow: hidden;
  background: $ps-canvas;
  height: 100%;
  transition: box-shadow 120ms ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(20, 22, 31, 0.1);
  }
}
// The blog cards use photos that fill the band edge to edge. These are
// transparent SVG illustrations, so the band keeps the card fill — giving it
// a white background made the card's top half disappear into the page.
.image {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 18px 0;

  img {
    width: 100%;
    height: 170px;
    object-fit: contain;
  }
}
.card-title {
  color: $ps-ink;
  height: 70px;
  text-align: center;
  font-size: $ps-text-body;
  font-weight: 600;
  line-height: 1.3;
}
.read-more {
  max-width: 130px;
  margin: 0 auto;
}
.image-container {
  flex-direction: column;
  gap: 20px;
  @include tablet {
    flex-direction: row;
    align-items: stretch;

    // Equal-width columns only once the cards sit side by side.
    > div {
      flex: 1;
    }
  }
  border-bottom: 1px solid $ps-border;
}
</style>
